import React, { useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import Markdown from 'react-commonmark';
import { Field } from 'redux-form';
import { CheckboxGroup } from '../../../../../../../../common/components/ReduxFormField';
import displayCurrency from '../../../../../../../../helpers/displayCurrency';
import { acceptance, required } from 'redux-form-validators';
import { isBroker } from '../../../../../../../auth/redux/authActions';

import PaymentIFrame from '../../../../../../../../common/components/PaymentIFrame/PaymentIFrame';
import getPaymentOptions from '../../../../../../../../helpers/getPaymentOptions';
import {
  HorizontalFormControl,
  PaymentOptions,
} from '../../../../../../../../common/components';
import getOwnerBrokerType from '../../../../../../../../helpers/getOwnerBrokerType';
import './PaymentTab.scss';
import { Refund } from '../../../../../Refund/Refund';

const transformDocLinks = (url, documents) => {
  if (url === 'policy_wording') {
    return documents['Policy Wording'];
  } else if (url === 'policy_summary') {
    return documents['Policy Summary'];
  } else if (url === 'tobca') {
    return documents['Terms of Business Customer Agreement'];
  }

  return url;
};

const Error = ({ message }) => {
  if (!message) {
    return null;
  }
  return <Alert bsStyle={'danger'}>PaymentError: {message}</Alert>;
};
const TotalToPay = ({ gross, taxRate }) => {
  if (!gross) {
    return null;
  }

  return (
    <Row>
      <Col sm={12}>
        <div className="total-premium">
          <span>Total to pay: </span>
          <span className="total-premium red">
            {displayCurrency(gross)}
            <span className={'ipt-label'}>
              &nbsp;including {taxRate}% Insurance Premium Tax (IPT)
            </span>
          </span>
        </div>
      </Col>
    </Row>
  );
};

const Declaration = ({ isMta, declaration, premium }) => {
  if (isMta || !declaration) {
    return null;
  }
  const transform = (url) => {
    return transformDocLinks(url, premium.attributes.scheme.documents);
  };

  return (
    <div className={'sl-payment-tab--declaration'}>
      <Row>
        <Col sm={12}>
          <h4>Declaration</h4>

          <div>
            <div className="declaration">
              <Markdown
                linkTarget="_blank"
                source={declaration}
                transformLinkUri={transform}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <Field
            name={'meta.purchase_declaration'}
            inline
            options={[
              {
                label: 'Are you happy to proceed on this basis?',
                value: true,
              },
            ]}
            validate={acceptance({ msg: 'Please confirm the above declaration' })}
            component={CheckboxGroup}
          />
        </Col>
      </Row>
    </div>
  );
};

const PaymentTab = ({
  purchaseDeclaration,
  salesChannel,
  finalPremium,
  isMta,
  isPurchaseDeclarationAgreed,
  isRefund,
  paymentType,
  onRedirectToIssued,
}) => {
  const [cardError, setCardError] = useState();

  const gross = finalPremium?.attributes?.gross;
  const organisationType = isBroker() ? 'Broker' : getOwnerBrokerType(salesChannel);
  const showRefund = isMta && gross < 0;
  const isAp = isMta && gross > 0;

  return (
    <div className={'sl-quote-tab sl-payment-tab'}>
      <Row>
        <Col sm={12} xs={12} lg={12} xl={12}>
          <div>
            <Row>
              <Col sm={12}>
                <h4>Payment Details</h4>
              </Col>
            </Row>
            <TotalToPay
              gross={finalPremium?.attributes.gross}
              taxRate={finalPremium?.attributes.tax_rate}
            />
          </div>

          <Declaration
            declaration={purchaseDeclaration}
            premium={finalPremium}
            isMta={isMta}
          />

          <Refund isRefund={isRefund} show={showRefund} />
          {(isPurchaseDeclarationAgreed || isAp) && (
            <>
              <Row>
                <Col sm={12}>
                  <div className="sl-payment-tab--pay-method-title">
                    Please select a payment method:
                  </div>
                  <PaymentOptions
                    selectedButtonType={paymentType}
                    paymentOptions={getPaymentOptions(organisationType)}
                    validate={required({ msg: 'Payment Type is required' })}
                  />
                </Col>
              </Row>
            </>
          )}
          <Error message={cardError} />
          <PaymentIFrame onSuccess={onRedirectToIssued} onFail={setCardError} />
          {(paymentType === 'cash' || paymentType === 'cheque') && (
            <div className="card-details">
              <Row>
                <Col sm={8}>
                  <Field
                    labelSize={12}
                    fieldSize={4}
                    paddingLabelTitle
                    label="Payment Reference"
                    name={'meta.payment_reference'}
                    component={HorizontalFormControl}
                  />
                </Col>
              </Row>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PaymentTab;
